/**
 * @packageDocumentation
 * @module api.functional.auth.reset_password.confirm
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ResetPasswordDto } from "../../../../structures/ResetPasswordDto";
import type { ServiceResponsenull } from "../../../../structures/ServiceResponsenull";

/**
 * @controller AuthController.resetPassword
 * @path POST /auth/reset-password/confirm
 * @accessor api.functional.auth.reset_password.confirm.resetPassword
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function resetPassword(
  connection: IConnection,
  body: resetPassword.Body,
): Promise<resetPassword.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...resetPassword.METADATA,
      template: resetPassword.METADATA.path,
      path: resetPassword.path(),
    },
    body,
  );
}
export namespace resetPassword {
  export type Body = ResetPasswordDto;
  export type Output = ServiceResponsenull;

  export const METADATA = {
    method: "POST",
    path: "/auth/reset-password/confirm",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/auth/reset-password/confirm";
}
